document.addEventListener('DOMContentLoaded', function () {
  var kmrCompareCache = {};

  function getDisplayedCurrencyCode() {
  var metaCurrency = document.querySelector('meta[property="og:price:currency"]');
  if (metaCurrency && metaCurrency.content) return metaCurrency.content.trim().toUpperCase();

  var shopifyCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
  if (shopifyCurrency) return String(shopifyCurrency).toUpperCase();

  return 'GBP';
}

  function parseMoneyToNumber(value) {
    if (value == null) return 0;
    var str = String(value).replace(/,/g, '').replace(/[^\d.]/g, '').trim();
    var num = parseFloat(str);
    return isNaN(num) ? 0 : num;
  }

  function formatGBP(value) {
    var num = parseMoneyToNumber(value);
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(num);
  }

  function getEmbeddedCompareMap() {
    var el = document.getElementById('kmr-boost-compare-map');
    if (!el) return null;

    try {
      var parsed = JSON.parse(el.textContent || '{}');
      return Object.keys(parsed).length ? parsed : null;
    } catch (e) {
      console.error('Failed to parse embedded compare map', e);
      return null;
    }
  }

  function getBoostRoot() {
    return (
      document.querySelector('.boost-sd-container-search-page') ||
      document.querySelector('.boost-sd-layout') ||
      document.querySelector('.boost-sd-container')
    );
  }

  function getCards(root) {
    if (!root) return [];
    return Array.from(root.querySelectorAll('.boost-sd__product-item[data-product-handle]'));
  }

  function getCurrentPriceFromCard(card) {
    var priceRoot = card.querySelector('.boost-sd__product-price');
    if (!priceRoot) return 0;

    var candidates = Array.from(priceRoot.querySelectorAll('.boost-sd__format-currency'));
    candidates = candidates.filter(function (el) {
      return !el.closest('.kmr-boost-compare-price');
    });

    if (!candidates.length) return 0;

    return parseMoneyToNumber(candidates[0].textContent || '');
  }

  function ensureSaleSash(card, label) {
    var imageWrap =
      card.querySelector('.boost-sd__product-image-wrapper') ||
      card.querySelector('.boost-sd__product-image') ||
      card.querySelector('.boost-sd__product-link') ||
      card;

    if (!imageWrap) return;

    var existing = card.querySelector('.kmr-boost-sale-sash');
    if (existing) {
      existing.textContent = label;
      return;
    }

    if (getComputedStyle(imageWrap).position === 'static') {
      imageWrap.style.position = 'relative';
    }

    var sash = document.createElement('div');
    sash.className = 'kmr-boost-sale-sash';
    sash.textContent = label;
    imageWrap.appendChild(sash);
  }

  function removeSaleSash(card) {
    var existing = card.querySelector('.kmr-boost-sale-sash');
    if (existing) {
      existing.remove();
    }
  }

  function removePromoImageSash(card) {
    var existing = card.querySelector('.kmr-boost-promo-image-sash');
    if (existing) {
      existing.remove();
    }
  }

  function ensurePromoImageSash(card, imageUrl) {
    if (!imageUrl) return;

    var imageWrap =
      card.querySelector('.boost-sd__product-image-wrapper') ||
      card.querySelector('.boost-sd__product-image') ||
      card.querySelector('.boost-sd__product-link') ||
      card;

    if (!imageWrap) return;

    if (getComputedStyle(imageWrap).position === 'static') {
      imageWrap.style.position = 'relative';
    }

    var existing = card.querySelector('.kmr-boost-promo-image-sash');
    if (existing) {
      var existingImg = existing.querySelector('img');
      if (existingImg && existingImg.getAttribute('src') !== imageUrl) {
        existingImg.setAttribute('src', imageUrl);
      }
      return;
    }

    var wrap = document.createElement('div');
    wrap.className = 'kmr-boost-promo-image-sash';

    var img = document.createElement('img');
    img.src = imageUrl;
    img.alt = '';
    img.loading = 'eager';

    wrap.appendChild(img);
    imageWrap.appendChild(wrap);
  }

  function ensureComparePrice(card, compareAt) {
    var priceRoot = card.querySelector('.boost-sd__product-price');
    if (!priceRoot) return;

    var existing = priceRoot.querySelector('.kmr-boost-compare-price');
    if (existing) {
      existing.textContent = formatGBP(compareAt);
      return;
    }

    var compare = document.createElement('div');
    compare.className = 'kmr-boost-compare-price';
    compare.textContent = formatGBP(compareAt);

    priceRoot.insertBefore(compare, priceRoot.firstChild);
  }

  function fetchCompareMap(handles) {
    if (!handles.length) return Promise.resolve({});

    var url = 'https://kmrapp.com/api/compare-at?handles=' + encodeURIComponent(handles.join(','));

    return fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed compare-at fetch');
        return res.json();
      })
      .catch(function (err) {
        console.error('KMR compare-at fetch failed:', err);
        return {};
      });
  }

  function enhanceCards(cards) {
    cards.forEach(function (card) {
      if (card.dataset.kmrEnhanced === 'true') return;

      var handle = card.getAttribute('data-product-handle');
      if (!handle) return;

      var data = kmrCompareCache[handle];
      if (!data) {
        
        return;
      }

      var promoImageUrl =
        typeof data.promo_image_url === 'string'
          ? data.promo_image_url.trim()
          : '';

      if (promoImageUrl.indexOf('//') === 0) {
        promoImageUrl = window.location.protocol + promoImageUrl;
      }

      var hasPromoImage =
        promoImageUrl &&
        /^https?:\/\//.test(promoImageUrl);

      if (hasPromoImage) {
        ensurePromoImageSash(card, promoImageUrl);
      } else {
        removePromoImageSash(card);
      }

      var activeCurrency = getDisplayedCurrencyCode();
      var allowCompareSash = activeCurrency === 'GBP';
      var hasCompare = !!data.compare_at_price && allowCompareSash;

      if (hasCompare) {
        var compareAt = Math.round(parseMoneyToNumber(data.compare_at_price) * 1.2 * 100) / 100;
        var currentPrice = getCurrentPriceFromCard(card);

        if (compareAt > 0 && currentPrice > 0 && compareAt > currentPrice) {
          ensureComparePrice(card, compareAt);

          if (!hasPromoImage) {
            var discountPct = Math.round(((compareAt - currentPrice) / compareAt) * 100);
            ensureSaleSash(card, discountPct > 0 ? ('SAVE ' + discountPct + '%') : 'SALE');
          } else {
            removeSaleSash(card);
          }
        } else {
          removeSaleSash(card);
        }
      } else {
        removeSaleSash(card);
      }

      card.dataset.kmrEnhanced = 'true';
    });
  }

  function runEnhancement() {
  var root = getBoostRoot();
  if (!root) return false;

  var cards = getCards(root);
  if (!cards.length) return false;

  var embeddedMap = getEmbeddedCompareMap();
  if (embeddedMap) {
    Object.keys(embeddedMap).forEach(function (handle) {
      kmrCompareCache[handle] = embeddedMap[handle];
    });
  }

  var handles = [];
  cards.forEach(function (card) {
    var handle = card.getAttribute('data-product-handle');
    if (!handle) return;
    if (kmrCompareCache.hasOwnProperty(handle)) return;
    if (handles.indexOf(handle) !== -1) return;
    handles.push(handle);
  });

  if (!handles.length) {
    enhanceCards(cards);
    return true;
  }

  fetchCompareMap(handles).then(function (map) {
    handles.forEach(function (handle) {
      kmrCompareCache[handle] = map[handle] || null;
    });

    enhanceCards(cards);
  });

  enhanceCards(cards);
  return true;
}

  function bindObserver(root) {
    if (!root || root.dataset.kmrCompareObserverBound === 'true') return;
    root.dataset.kmrCompareObserverBound = 'true';

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(function () {
        scheduled = false;
        runEnhancement();
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  function startWhenCardsExist(attempt) {
    attempt = attempt || 0;

    var root = getBoostRoot();
    var cards = getCards(root);

    if (root && cards.length) {
      runEnhancement();
      bindObserver(root);
      return;
    }

    if (attempt > 80) {
      if (root) {
        runEnhancement();
        bindObserver(root);
      }
      return;
    }

    setTimeout(function () {
      startWhenCardsExist(attempt + 1);
    }, 50);
  }

  startWhenCardsExist();
});